import { Component, ElementRef, OnChanges, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs/Subscription';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from "ph-bhp-localization";
import { PhpBhpCheckChartExportComponent } from '../php-bhp-check-chart-export/php-bhp-check-chart-export.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CheckStorageService, DownloadModalComponent, HygieneCheckPageComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/components/dialog/confirm-dialog/confirm-dialog.component';
import { DateToGermanPipe } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/pipes/dateToGerman';
import { DownloadModalStatus } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/models/global-interface';
import { DownloadModalService } from '../../../ph-bhp-feature-package-check/lib/services/download-modal.service';

@Component({
  selector: 'app-hygiene-check-evaluation-individual-data',
  templateUrl: './hygiene-check-evaluation-individual-data.component.html',
  styleUrls: ['./hygiene-check-evaluation-individual-data.component.css']
})
export class HygieneCheckEvaluationIndividualDataComponent implements OnInit, OnChanges, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  reportKey: string = "IndividualAuditData";
  pageTitle = 'EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW';

  userSubscription: Subscription;
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  subscription: Subscription;

  data;
  filterDetails = [];
  isDesktop = true;

  @ViewChild('exportTag', { static: true }) exportTag: PhpBhpCheckChartExportComponent;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;

  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE',
  };
  userData: any;

  public clickImageBtn = false;
  public clickPdfBtn = false;
  public clickExcelBtn = false;

  questionnaireDetail: any[];
  userID;
  roleId;
  appName = 'Hygiene Check';
  filterIndices: number[] = [0];
  evaluationLoaded: boolean = false;
  originalData: any;
  individualDataResponse: any;
  isEvaluationTable: boolean = true;
  results: any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  questionnaires: { id: string, questionnaireName: string, institutionName: string }[] = [];
  fields: any[] = [
    { 'field': 'questionnaireName', 'title': 'CHECK.EVALUATION.QUESTIONNAIRE' },
    { 'field': 'date', 'title': 'CHECK.EVALUATION.DATE' },
    { 'field': 'institutionName', 'title': 'CHECK.EVALUATION.INSTITUTION' },
    { 'field': 'departmentName', 'title': 'CHECK.EVALUATION.DEPARTMENT' },
    { 'field': 'departmentTypeName', 'title': 'CHECK.EVALUATION.DEPARTMENT_TYPE' },
    { 'field': 'wardName', 'title': 'CHECK.EVALUATION.WARD' },
    { 'field': 'furtherParticipant', 'title': 'CHECK.EVALUATION.FURTHER_PARTICIPANT' },
    { 'field': 'stationAudits', 'title': 'CHECK.EVALUATION.PICTURES_TAKEN' },
    { 'field': 'score', 'title': 'CHECK.EVALUATION.OVERALL_SCORE' },
  ];
  gridData: Array<any>;
  isSelectable: boolean = true;
  multiSelectText: string = "";
  actionItems: any = [
    { name: 'LAYOUT_MODULE.VIEW', imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg', onClick: (dataItem) => { this.viewQuestionnaire(dataItem) } },
    { name: 'EVALUATION.DOWNLOAD', imgSrc: 'assets/ph-bhp-layout/svg/download-icon-blue.svg', onClick: (dataItem) => { this.openDownloadQuestionnaireModal(dataItem) } },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(dataItem) } },
  ];
  questionnairesIDs: Array<any> = [];

  @ViewChild('gridTable') gridTable;

  modalRef: BsModalRef;
  deleteData;
  questionnaireData;
  deleteSelectionText: string = "";

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public checkStorageService: CheckStorageService,
    public downloadModalService: DownloadModalService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.appConfig.filterDetails ? this.filterDetails = this.appConfig.filterDetails : this.filterDetails = [];
  }

  private scrollListener: any;
  ngAfterViewInit() {
    this.scrollListener = (event) => {
      const dropdownMenu = event.target as HTMLElement;
      if (dropdownMenu.classList.contains('dropdown-menu')) {
        return;
      }
      this.checkDropdownPositions(event);
    };

    document.addEventListener('scroll', this.scrollListener, true);
  }

  checkDropdownPositions(event) {
    const dropdowns: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('.dropdown-container-input');
    const scrollTop = event.target.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;

    dropdowns.forEach(dropdown => {
      const rect = dropdown.getBoundingClientRect();
      const top = rect.top + scrollTop;
      if (top < scrollTop || top + rect.height > scrollTop + windowHeight) {
        if (dropdown.getAttribute('aria-expanded') === 'true') {
          dropdown.dispatchEvent(new Event('click'));
        }
      }
    });
  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.userData = this.appConfig.userData;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW");
        if (this.userHasFilter) {
          this.evaluate(true);
        } else {
          this.layoutService.showLoader = false;
        }
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW");
    this.ngOnChanges();
  }

  selectedQuestionnaires: any[] = [];
  ngOnChanges(): void {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;

    if (!this.isUserFilterSetted) {
      this.evaluationService.getQuestionnairesByUserAndCountry(this.appConfig.userData.userId, this.appConfig.userData.country).subscribe((questionnaires: any) => {
        this.questionnaires = questionnaires;
        //this.questionnaireDetail = this.questionnaires.sort((a, b) => this.compareQuestionnaireTitles(a,b ));
        this.evaluationService.getUserHasCheckEvaluationFilter(this.appConfig.userData.userId, this.reportKey).subscribe((userHasFilter) => {
          this.isUserFilterSetted = true;
          if (this.appConfig.checkGeneralFilter != null) {
            userHasFilter = this.appConfig.checkGeneralFilter;
          }

          if (userHasFilter) {
            if (userHasFilter.questionnaireIds && userHasFilter.questionnaireIds.length > 0) {
              var selectedQuestionnaires = userHasFilter.questionnaireIds.map((id) => {
                var questionnaire = this.questionnaires.find(questionnaire => questionnaire.id == id);
                if (questionnaire) {
                  return {
                    id: questionnaire.id,
                    questionnaireName: questionnaire.questionnaireName,
                    institutionName: questionnaire.institutionName
                  }
                } else {
                  return null;
                }
              });

              this.selectedQuestionnaires = selectedQuestionnaires.filter(res => res != null);
            } else {
              this.selectedQuestionnaires = [];
            }

            this.userHasFilter = true;
            this.userFilters = userHasFilter.filters;
            setTimeout(() => { this.initComponent(); });
          } else {
            this.userFilters = [];
            this.noDataFound = true;
            this.filters.get(0).showFilter();
          }
        }, (error) => { }, () => { this.layoutService.showLoader = false; })
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent() });
    }
  }

  resetQuestionnaireFilter() {
    this.selectedQuestionnaires = [];
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
    if (this.institutionSubscription) this.institutionSubscription.unsubscribe();
    if (this.userSubscription) this.userSubscription.unsubscribe();
    if (this.scrollListener) document.removeEventListener('scroll', this.scrollListener, true);
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
    }

    if (this.appConfig.userData) {
      this.loadFiltersInfo();
      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.data = {
      filters: [],
      roleId: this.roleId,
      questionnaireIds: this.selectedQuestionnaires.length > 0 ? this.selectedQuestionnaires.map(res => res.id) : [],
    };

    if (initialize) {
      this.data.filters = this.userFilters;
    } else {
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          institutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filters.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.userHasFilter = true;
    if (getResults == true) {
      this.getCheckIndividualData(this.userID, this.data);
    } else if (getResults == false) {
      this.saveCheckIndividualDetails(this.userID, this.data);
    }
  }

  compareQuestionnaireTitles(a, b) {
    var aTitleTranslated = this.getQuestionnaireTranslation(a.title);
    var bTitleTranslated = this.getQuestionnaireTranslation(b.title);
    if (aTitleTranslated < bTitleTranslated) return -1;
    if (aTitleTranslated > bTitleTranslated) return 1;
    return 0;
  }

  getQuestionnaireTranslation(title) {
    return this.layoutService.translateText(title, '');
  }

  manageGrid(questionnaire, that) {
    let lang = localStorage.getItem('selectedlanguage');
    if (questionnaire.createdDataTime) {
      const date1 = this.layoutService.convertUTCDateToLocalDate(questionnaire.createdDataTime);
      questionnaire.createdDataTime = date1.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' });
    }
    return questionnaire;
  }

  getCheckIndividualData(userID, data) {
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getCheckIndividualAuditData(userID, this.isSavedFromEvaluation, data).subscribe((res: any) => {
      this.originalData = JSON.parse(JSON.stringify(res));
      const data = res['checkIndividualData'].map((item) => {
        var questionnaire = this.questionnaires.find(res => res.id == item.questionnaireId);
        if (!questionnaire) {
          var institutionQuestionnaires = this.questionnaires.filter(res => res.institutionName == item.institutionName);
          if (institutionQuestionnaires.length > 0) {
            questionnaire = institutionQuestionnaires[0];
          } else {
            return null;
          }
        }
        let row = {
          id: item.id,
          questionnaireName: questionnaire.questionnaireName,
          originalDate: item.date,
          date: new Date(item.date).toLocaleDateString(this.translate.currentLang, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }),
          institutionName: item.institutionName,
          departmentName: this.layoutService.translateText(item.departmentName),
          departmentTypeName: this.layoutService.translateText(item.departmentTypeName),
          wardId: item.wardID,
          wardName: item.wardName,
          furtherParticipant: item.furtherParticipant != "" ? item.furtherParticipant : "-",
          stationAudits: item.stationAudits,
          score: item.score == -1 ? "N/A" : (item.score * 100).toFixed(2) + '%',
        }
        return row;
      });

      this.gridData = data.filter((item) => item != null);
      this.layoutService.showLoader = false;
    })
  }

  saveCheckIndividualDetails(userID, data) {
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    this.evaluationService.saveCheckSummarisedDetails(userID, this.isSavedFromEvaluation, this.reportKey, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    }, (error) => { this.layoutService.showLoader = false; })
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.checkGeneralFilter = this.data;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
      this.appConfig.checkGeneralFilter = null;
    }

    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/hygiene-check/statistical']); break;
      case 'quickCommentsAnalysis': this.router.navigate(['evaluation/hygiene-check/quickComments']); break;
      case 'overallComplianceScore': this.router.navigate(['evaluation/hygiene-check/overallCompliance']); break;
      case 'individualAuditDataOverview': this.router.navigate(['evaluation/hygiene-check/individualData']); break;
      default: this.router.navigate(['evaluation/hygiene-check/statistical']); break;
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();

        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiselectFilter, filter.multiselectValues, true);
          }
        }
      });
    }, 500);
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true) }, 1000);
    }
  }

  resetExportAs(value: 'excel') {
    switch (value) {
      case 'excel':
        this.clickExcelBtn = false;
        break;
    }
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  resetFilters() {
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.selectedQuestionnaires = [];
    this.layoutService.showLoader = true;
    setTimeout(() => { this.evaluate(true) }, 1500);
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onMultiselectChange(event: Event) {
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  trackLoop(index: number, item: any) {
    return item;
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) { return; }
    this.evaluate(true);
  }

  viewQuestionnaire(questionnaire) {
    localStorage.setItem('departmentName', questionnaire.departmentName);
    localStorage.setItem('wardName', questionnaire.wardName);
    localStorage.setItem('wardId', questionnaire.wardId.toString());
    this.appConfig.checkId = questionnaire.id;
    const urlTree = this.router.createUrlTree(['/hygiene-check-menu/view', questionnaire.id], { queryParams: { from: 'checkIndividualData' } });
    this.router.navigateByUrl(urlTree);
  }

  closeSubscription: Subscription;
  openDownloadQuestionnaireModal(data) {
    const dateTo = DateToGermanPipe.prototype.transformToDownloadModal(data.originalDate);
    const status: DownloadModalStatus = {
      type: 'check',
      id: data.id,
      institutionName: data.institutionName,
      wardName: data.wardName,
      departmentName: this.layoutService.translateText(data.departmentName),
      creationHour: dateTo[0],
      creationDate: dateTo[1],
      username: ''
    };

    this.downloadModalService.setDownloadModal(status);
    this.closeSubscription = this.downloadModalService.closeModal$.subscribe((res) => {
      if (res) {
        const modal: any = this.el.nativeElement.querySelector('#downloadModal');
        this.renderer.setStyle(modal, 'display', 'none');
        this.renderer.removeClass(modal, 'show');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('aria-modal', 'false');
        this.closeSubscription.unsubscribe();
      }
    });
    setTimeout(() => {
      const modal: any = this.el.nativeElement.querySelector('#downloadModal');
      this.renderer.setStyle(modal, 'display', 'block');
      this.renderer.addClass(modal, 'show');
      modal.setAttribute('aria-hidden', 'false');
      modal.setAttribute('aria-modal', 'true');
      modal.focus();
    })
  }

  async openDeleteModal(data) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = "343px";
    dialogConfig.panelClass = "confirm-dialog-container";
    dialogConfig.data = {
      title: this.layoutService.translateText('CHECK.DELETE_CHECK_QUESTION_TITLE'),
      message: this.layoutService.translateText('CHECK.DELETE_CHECK_QUESTION_MESSAGE'),
      id: data.id,
      textCancel: this.layoutService.translateText('BUTTON.CANCEL'),
      textConfirm: this.layoutService.translateText('LAYOUT_MODULE.DELETE'),
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.checkStorageService.deleteCheck(data.id).subscribe({
          next: () => {
            this.evaluate(true);
          },
          error: (err: any) => {
            console.log('Error al eliminar el check', err);
          }
        });
      }
    })
  }

  showDeleteSelectionModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = "343px";
    dialogConfig.panelClass = "confirm-dialog-container";
    var selectedRows = this.gridTable.getSelectedRows();
    if (selectedRows.length == 0) {
      this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.NO_RECORD_SELECTED'));
      return;
    }

    const deleteSelectionText = this.layoutService.translateText('ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD_SELECTION');
    const deleteSelectionTextWithCount = deleteSelectionText.replace('{0}', selectedRows.length.toString());
    dialogConfig.data = {
      title: this.layoutService.translateText(this.translationKeys.InstitutionManagement.Confirmation),
      message: deleteSelectionTextWithCount,
      textCancel: this.layoutService.translateText('BUTTON.CANCEL'),
      textConfirm: this.layoutService.translateText('LAYOUT_MODULE.DELETE'),
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.layoutService.showLoader = true;
        var selectedRows = this.gridTable.getSelectedRows();
        var checkIds = selectedRows.map(row => row.id);
        this.layoutService.showLoader = true;
        this.checkStorageService.deleteChecks(checkIds).subscribe(res => {
          this.evaluate(true);
        }, error => {
          this.layoutService.showLoader = false;
        });
      }
    })
  }
}
